import { gql } from "@apollo/client";

const userLoginFields = `
  id
  firstName
  lastName
  email
  profile {
    id
    memberSince
  }
`;

const userCredentialsFields = `
  accessToken
  client
  expiry
  tokenType
  uid
`;

const USER_LOGIN_FIELDS = gql`
  fragment UserLoginFields on User {
    ${userLoginFields}
  }
`;

const USER_CREDENTIALS_FIELDS = gql`
  fragment UserCredentialsFields on Credential {
    ${userCredentialsFields}
  }
`;

export { USER_LOGIN_FIELDS, USER_CREDENTIALS_FIELDS };
